// Analytics-consent capability facade — mirrors the telemetry facade: feature
// code imports the capability, never a vendor.
//
// No banner vendor is currently installed (AdOpt was removed 2026-08-26 by
// product ruling: consent management moves to a personal-data platform,
// VER-396). Until that platform's cookie module lands, consent resolves to
// 'granted' unconditionally and never changes, so telemetry starts as it did
// before the banner existed. The telemetry client stays wired to BOTH surfaces
// below — including the grant→deny→grant transitions its consent-gate spec
// pins — so the future adapter only has to implement this contract.

export type AnalyticsConsentStatus = 'granted' | 'denied' | 'unresolved';

/** May analytics run? Always, until a consent-management vendor is installed. */
export function getAnalyticsConsent(): AnalyticsConsentStatus {
  return 'granted';
}

/** Fires on every consent change; with no vendor installed the status never changes. */
export function onAnalyticsConsent(
  _callback: (status: AnalyticsConsentStatus) => void,
): () => void {
  return () => {};
}
